import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function InputField({
  title,
  id,
  value,
  onChange,
  pull = false,
  type = "text",
  direction = "rtl",
  required = false,
  isDisabled = false,
  autoComplete = "",
  classes = "",
}) {
  const [showPassword, setShowPassword] = useState(false);
  const wrapperClass = pull ? "relative md:col-span-2" : "relative";
  const labelClass = "text-sm font-medium";
  const inputClass = `portal-input mt-2 block w-full px-4 py-2.5 ${classes}`;

  if (type === "date")
    return (
      <div className={pull ? "md:col-span-2" : ""}>
        <label className={labelClass} style={{ color: "var(--layout-text)" }}>
          {title}
        </label>
        {required ? <span className="font-bold text-red-600">*</span> : ""}
        <input
          id={id}
          name={id}
          type={type}
          placeholder={title}
          required={required}
          autoComplete={autoComplete}
          onChange={(e) => onChange(e.target)}
          className={inputClass}
        />
      </div>
    );

  if (type === "select")
    return (
      <div className={pull ? "md:col-span-2" : ""}>
        <label className={labelClass} style={{ color: "var(--layout-text)" }}>
          {title}
        </label>
        {required ? <span className="font-bold text-red-600">*</span> : ""}
        <select
          className={inputClass}
          onChange={(e) => onChange(e.target.value)}
        >
          {value.map((selector, index) => {
            return <option key={index}>{selector}</option>;
          })}
        </select>
      </div>
    );

  if (type === "file")
    return (
      <div className={pull ? "md:col-span-2" : ""}>
        <label className={labelClass} style={{ color: "var(--layout-text)" }}>
          {title}
        </label>
        {required ? <span className="font-bold text-red-600">*</span> : ""}
        <input
          className="portal-input mt-2 w-full cursor-pointer rounded-xl px-2 py-2 file:ml-3 file:cursor-pointer file:rounded-xl file:border-0 file:bg-[var(--layout-accent)] file:px-3 file:py-2 file:text-white"
          type="file"
          accept="image/png, image/jpeg, image/jpg"
          autoComplete={autoComplete}
          onChange={(e) => onChange(e.target.files[0])}
          required={required}
        />
      </div>
    );

  return (
    <div className={wrapperClass}>
      <label className={labelClass} style={{ color: "var(--layout-text)" }}>
        {title}
      </label>
      {required ? <span className="font-bold text-red-600">*</span> : ""}
      <input
        id={id}
        name={id}
        type={type === "password" ? (!showPassword ? "password" : "text") : type}
        className={inputClass}
        style={{ direction }}
        value={value}
        autoComplete={autoComplete}
        onChange={(e) => onChange(e.target)}
        required={required}
        disabled={isDisabled}
      />
      {type === "password" ? (
        <span
          title="عرض/إخفاء كلمة المرور"
          onClick={() => setShowPassword((prev) => !prev)}
          className="portal-outline-button absolute bottom-[7px] right-[7px] cursor-pointer rounded-lg p-2"
        >
          {!showPassword ? (
            <FaEye style={{ color: "var(--layout-text)" }} />
          ) : (
            <FaEyeSlash style={{ color: "var(--layout-text)" }} />
          )}
        </span>
      ) : null}
    </div>
  );
}
